// 🥕 당근(인앱 재화) 구매 패키지 — 단일 출처 (공개 /pricing + 인앱 /currency/gather 공용).
//  KR 기준: 1당근 = 10원, KRW 가격 = 부가세 10% 포함 최종가(공급가 × 1.1).
//  실제 청구/세금은 결제(Paddle, MoR)가 지역별로 최종 확정 — 여기 값은 "표시용 세금포함 가격".
//  ⚠️ USD/JPY는 잠정값(심리가) — Paddle 제출/연동 전 확정 필요. KRW만 확정.
export const CARROT_PACKAGES = [
  { carrots: 100, bonus: 0, price: { KRW: 1100, USD: 0.99, JPY: 150 } },
  { carrots: 500, bonus: 0, price: { KRW: 5500, USD: 4.99, JPY: 700 } },
  { carrots: 1000, bonus: 0, price: { KRW: 11000, USD: 9.99, JPY: 1500 } },
  { carrots: 3000, bonus: 0, price: { KRW: 33000, USD: 29.99, JPY: 4500 } },
];

// 지원 통화 + 로케일 매핑 (미지원 로케일 → USD 폴백)
export const LOCALE_CURRENCY = { ko: "KRW", en: "USD", ja: "JPY" };
export function currencyForLocale(locale) {
  return LOCALE_CURRENCY[locale] || "USD";
}

// 통화별 포맷 (KRW/JPY는 소수점 없음 — Intl이 자동 처리)
export function formatPrice(amount, currency, locale) {
  return new Intl.NumberFormat(locale || "en", { style: "currency", currency }).format(amount);
}
